import { network } from 'services/network';

export const getRowDrillDownActivities = (params) => {
    return network.post('api/bo/getRowDrillDownActivities', params).then((response) => {
        return response.data;
    });
};
